import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card, Row, Col, Table, Popover,ConfigProvider,theme } from 'antd';
import { QuestionCircleOutlined,DownloadOutlined } from '@ant-design/icons';
import help from '../../config/help.json';
import { CSVLink } from 'react-csv';



import './analytics.css';


var cc_data;

class PlusPurchaseRentCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
		 }
	}

	async componentDidUpdate(prevProps) {
	}



	render() {
		const { defaultAlgorithm, darkAlgorithm } = theme;
		const {  userTheme,opensearchPlusPurchaseRentList } = this.props;

		cc_data = opensearchPlusPurchaseRentList || [];
		let dataset = [];
		cc_data.forEach(d =>{
			if(d.paymentType && d.paymentType.buckets ){
				d.paymentType.buckets.forEach(c => {
					dataset.push({planid:d.key, paymentType: c.key , doc_count: c.doc_count, key:crypto.randomUUID()});
				})
			}else{
				dataset.push({planid:d.key, paymentType: '' , doc_count: d.doc_count,key:crypto.randomUUID()})
			}
		})

		// takes an array of objects and the name of a property of these objects
		function getGroupByKeys(array, index){
			let temparr = [];
			array.forEach(d => {
				if(d && d[index]){
					if(!temparr.some(f => f.text === d[index])){
						temparr.push({text:d[index], value:d[index]})
					}
				}
			})
			return temparr;
		}

		const columns = [
			{
			  key: 'planId',
			  title: 'Plan ID',
			  dataIndex: 'planid',
			  filters: getGroupByKeys(dataset, "planid"),
			  onFilter: (value, record) => record.planid.indexOf(value) === 0,
			  sorter: (a, b) => a.planid.localeCompare(b.planid),
			  
			},
			{
			  key: 'paymentType',
			  title: 'Payment Type',
			  dataIndex: 'paymentType',
			  filters: getGroupByKeys(dataset, "paymentType"),
			  onFilter: (value, record) => record.paymentType.indexOf(value) === 0,
			  sorter: (a, b) => a.paymentType.localeCompare(b.paymentType),
			  
			},
			{
				key: 'count',
				title: 'Count',
				dataIndex: 'doc_count',
				sorter: (a, b) => a.doc_count - b.doc_count,
				defaultSortOrder: 'descend',
				
			  }
		  ];

		return (
			<ConfigProvider theme={{
				algorithm: userTheme === 'dark' ?darkAlgorithm : defaultAlgorithm,
			  }}>
      <Card className="analyticCard analyticActiveUsersCard">
				<h3 className="title">{`Rentals  `}
				<Popover placement="topLeft"
						overlayStyle={{width:'300px'}}
						content= {help.find(d=> d.name ==='PlusPurchaseRentCard').en}
						trigger="click"><QuestionCircleOutlined />
					</Popover>
					<CSVLink data={dataset} target="_blank" filename={"Rentals.csv"}>
						<DownloadOutlined />
					</CSVLink>
				</h3>
				<Row>
				 <Col span={24}>
				 	<Table style={{ height: 400, width: '100%' }} theme={userTheme} dataSource={dataset} columns={columns} pagination={{pageSize:5}}  />
					{/* <ReactECharts style={{ height: 320, width: '100%' }} theme={userTheme} option={option} notMerge={true} showLoading={loading} loadingOption={{color:"#74add1"}} /> */}
				</Col>
 				</Row>
     </Card>
	 </ConfigProvider>
		);
	}


}

const mapStateToProps = state => ({
	router: state.router,
	userTheme: state.user.userTheme,
	selectedOrganization: state.user.selectedOrganization,
	opensearchPlusPurchaseRentList: state.analytics.opensearchPlusPurchaseRentList
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
		},
		dispatch
	);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PlusPurchaseRentCard));
